const checkEls = document.querySelectorAll('.cart-check');
const cartBtn = document.querySelector('button[name="checkout"]');

// function to check if checked input els == checkbox parent els
function checkBoxes() {
  const checkedBoxes = document
    .querySelector('.cart__buttons')
    ?.querySelectorAll('input[name^="attributes"]:checked');
  if (checkedBoxes && checkEls) {
    return checkEls.length === checkedBoxes.length;
  } else {
    return true;
  }
}

if (checkEls && cartBtn) {
  // if for some reason the boxes checked on browser back or whatever
  cartBtn.toggleAttribute('disabled', !checkBoxes());

  for (let i = 0; i < checkEls.length; i++) {
    const checkbox = checkEls[i].querySelector('input[type="checkbox"]');
    checkbox.addEventListener('change', () => {
      if (!checkBoxes()) {
        cartBtn.toggleAttribute('disabled', true);
      }
      let updates = {
        attributes: {
          __tos: document.querySelector('#tos')?.checked ? "agreed" : "not agreed",
          __age: document.querySelector('#age')?.checked ? "agreed" : "not agreed"
        }
      };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        return response.json();
      }).then(data => {
        cartBtn.toggleAttribute('disabled', !checkBoxes());
      })
      .catch((error) => {
        console.error('Error:', error);
        cartBtn.toggleAttribute('disabled', !checkBoxes());
      });
    });
  }

  // show error if cart button is somehow enabled and clicked but checkbox is not checked
  cartBtn.addEventListener('click', (e) => {
    if (!checkBoxes()) {
      e.preventDefault();
    }
  });
}